import {translations} from 'presentation/translations-new';
import {FlowTypeEnumWithoutAuth} from 'presentation/utils';
import {CustomText} from './types';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';

const {
	headerTitle,
	description,
	examDescription,
	examHeaderTitle,
	teleHeaderTitle,
	teleDescription,
} = translations['pt-br'].privateFlow.bookingFlow.duplicityWarning;

const CUSTOM_TEXTS: Record<Exclude<FlowTypeEnumWithoutAuth, FlowEnum.SURGERY>, CustomText> = {
	HEALTH: {
		headerTitle,
		description,
	},
	TELEHEALTH: {
		headerTitle: teleHeaderTitle,
		description: teleDescription,
	},
	ODONTO: {
		headerTitle,
		description,
	},
	EXAM: {
		headerTitle: examHeaderTitle,
		description: examDescription,
	},
};

export {CUSTOM_TEXTS};
